import { render, staticRenderFns } from "./menuItem.vue?vue&type=template&id=6acadb8e&scoped=true&"
import script from "./menuItem.vue?vue&type=script&scoped=true&lang=js&"
export * from "./menuItem.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./menuItem.vue?vue&type=style&index=0&id=6acadb8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acadb8e",
  null
  
)

export default component.exports